<!-- <div class="spinner" [ngClass]="{'spinner-sm': size === 'small'}">
    <fa-icon [icon]="['fas', 'spinner']" class="fa-spin"></fa-icon>
  </div> -->

  <!-- <fa-icon [icon]="['fas', 'spinner']" class="spin spinner" [ngClass]="{'spinner-sm': size === 'small'}"></fa-icon> -->
  <img src="svg/spinner-svgrepo-com.svg" alt="" class="svg spin spinner">
